"use strict";

module.exports = function (accumulator, order, product, component) {
  return accumulator + (!component.version ? '' : "-Version".concat(component.version));
};